/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IGuardedLaunch,
  IGuardedLaunchInterface,
} from "../IGuardedLaunch";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newMaxDeposits",
        type: "uint256",
      },
    ],
    name: "DefaultSiloMaxDepositsLimitUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "globalPause",
        type: "bool",
      },
    ],
    name: "GlobalPause",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "newLimitedMaxLiquidityState",
        type: "bool",
      },
    ],
    name: "LimitedMaxLiquidityToggled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "silo",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newMaxDeposits",
        type: "uint256",
      },
    ],
    name: "SiloMaxDepositsLimitsUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "silo",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "pauseValue",
        type: "bool",
      },
    ],
    name: "SiloPause",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getMaxSiloDepositsValue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "isSiloPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxDeposits",
        type: "uint256",
      },
    ],
    name: "setDefaultSiloMaxDepositsLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_globalPause",
        type: "bool",
      },
    ],
    name: "setGlobalPause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_globalLimit",
        type: "bool",
      },
    ],
    name: "setLimitedMaxLiquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_maxDeposits",
        type: "uint256",
      },
    ],
    name: "setSiloMaxDepositsLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_pauseValue",
        type: "bool",
      },
    ],
    name: "setSiloPause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IGuardedLaunch__factory {
  static readonly abi = _abi;
  static createInterface(): IGuardedLaunchInterface {
    return new utils.Interface(_abi) as IGuardedLaunchInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IGuardedLaunch {
    return new Contract(address, _abi, signerOrProvider) as IGuardedLaunch;
  }
}
